import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";

import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkSpacingSpace } from "uitk-react-spacing/dist/types";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkText } from "uitk-react-text";

import { getFormattedHotelDates } from "components/flexComponents/Packages/utils/PackageDates";

interface LobHotelDetailsProps {
  isoCheckInDate: string;
  isoCheckOutDate: string;
  numberOfNights: number;
  topSpacing?: UitkSpacingSpace;
}

const LobHotelDetails = (props: LobHotelDetailsProps) => {
  const { isoCheckInDate, isoCheckOutDate, numberOfNights, topSpacing } = props;

  if (!Boolean(isoCheckInDate && isoCheckOutDate && numberOfNights)) {
    return null;
  }

  const { formatText } = useLocalization();

  return (
    <UitkSpacing margin={{ blockstart: topSpacing }}>
      <UitkLayoutFlex space="one">
        <UitkIcon name="lob_hotels" size={UitkIconSize.SMALL} />
        <UitkLayoutFlex direction="column">
          <UitkText size={300} weight="bold" theme="emphasis">
            {getFormattedHotelDates({
              checkInDate: isoCheckInDate,
              checkOutDate: isoCheckOutDate,
            })}
          </UitkText>
          <UitkText size={200}>{formatText("package.card.hotelNightStay", numberOfNights)}</UitkText>
        </UitkLayoutFlex>
      </UitkLayoutFlex>
    </UitkSpacing>
  );
};

export default LobHotelDetails;
